import React from 'react';
import { useDraggable } from '@dnd-kit/core';
import type { Player } from '../services/api';
import { Paper, Typography } from '@mui/material';

interface PlayerCardProps {
  player: Player;
  isDragging?: boolean; // Prop to indicate if this is a drag overlay representation
  isDragDisabled?: boolean;
}

const PlayerCard: React.FC<PlayerCardProps> = ({ player, isDragging: isOverlay = false, isDragDisabled = false }) => {
  const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({
    id: player.id,
    disabled: isDragDisabled,
  });

  const style = transform ? {
    transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
  } : undefined;

  // Do not attach listeners if dragging is disabled
  const appliedListeners = isDragDisabled ? undefined : listeners;

  return (
    <Paper 
      ref={setNodeRef} 
      style={style}
      elevation={isOverlay ? 6 : 1}
      {...appliedListeners} 
      {...attributes}
      sx={{
        p: 1.5,
        borderRadius: '6px',
        cursor: isDragDisabled ? 'default' : 'grab',
        opacity: isDragging && !isOverlay ? 0.5 : 1,
        transition: 'opacity 0.2s ease, box-shadow 0.2s ease',
        backgroundColor: 'background.paper',
        // Ensuring the dragged overlay has a definite box-shadow
        boxShadow: isOverlay 
          ? '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)' 
          : undefined,
      }}
    >
      <Typography variant="body1">{player.name}</Typography>
    </Paper>
  );
};

export default PlayerCard;